<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <component
    :is="tag"
    v-if="displayName && empNumber"
    :class="['orangehrm-buzz-employee-name', nameClass]"
    role="link"
    tabindex="0"
    @click="onClick"
    @keydown.enter="onClick"
  >
    {{ displayName }}
  </component>
  <component
    :is="tag"
    v-else-if="displayName"
    :class="[
      'orangehrm-buzz-employee-name',
      'orangehrm-buzz-employee-name--plain',
      nameClass,
    ]"
  >
    {{ displayName }}
  </component>
</template>

<script>
import {computed} from 'vue';
import useBuzzEmployeeMentionDialog from '@/orangehrmBuzzPlugin/util/composable/useBuzzEmployeeMentionDialog';
import useEmployeeNameTranslate from '@/core/util/composable/useEmployeeNameTranslate';

export default {
  name: 'BuzzEmployeeName',

  props: {
    employee: {
      type: Object,
      default: null,
    },
    tag: {
      type: String,
      default: 'span',
    },
    nameClass: {
      type: [String, Object, Array],
      default: null,
    },
    includeMiddle: {
      type: Boolean,
      default: true,
    },
    excludePastEmpTag: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const {$tEmpName} = useEmployeeNameTranslate();
    const {openEmployeeMention} = useBuzzEmployeeMentionDialog();

    const empNumber = computed(() => {
      const value = props.employee?.empNumber;
      if (value === null || value === undefined) {
        return null;
      }
      const parsed = Number(value);
      return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
    });

    const displayName = computed(() => {
      if (!props.employee) {
        return null;
      }
      return $tEmpName(props.employee, {
        preferNickname: true,
        excludePastEmpTag: props.excludePastEmpTag,
      });
    });

    const onClick = () => {
      if (!empNumber.value) {
        return;
      }
      openEmployeeMention(empNumber.value);
    };

    return {
      empNumber,
      displayName,
      onClick,
    };
  },
};
</script>

<style src="./buzz-employee-link.scss" lang="scss" scoped></style>
